import React, { useEffect } from "react";
import classes from "./LearnerClickComponent.module.css";
import LearClickComponent from "./LearClickComponent";
import { table_getInteractionsData } from "../../connections";

interface InteractionsData {
  "interaction name": string;
  count_of_learners: number;
  count_of_interacted: number;
}
type ApiResponse = {data: InteractionsData[]};
function LearnerClickContainer() {
  const [interactions, setInteractions] = React.useState<InteractionsData[]>([]);
  const [max_interaction,setMaxInteraction] = React.useState<number>(0);
  useEffect(() => {
    const getData = async () => {
      const result: ApiResponse = await table_getInteractionsData();
      const filteredData = result.data.filter(item => item["interaction name"].startsWith("Path Selected"));
      const maxCount = Math.max(...filteredData.map(item => item.count_of_interacted));
      setMaxInteraction(maxCount)
      setInteractions(filteredData);
    };
    getData();
  }, []);
  return (
      <>
          {interactions.length > 0 ? (
              <div className={classes.learnerContainer}>
                  <div className={classes.dataContainer}>
                      <h2 className={classes.metricsTitle}>
                          How often did the learner click each course path?{" "}
                      </h2>
                      {interactions.map((item, index) => (
                          <LearClickComponent
                              path_name={item["interaction name"]}
                              key={index}
                              index={index}
                              clicks={item.count_of_interacted}
                              max_interaction={max_interaction}
                          />
                      ))}
                  </div>
              </div>
          ) : null}
      </>
  );
}

export default LearnerClickContainer;
